import { AxisSwitcher, BorderGridContainer, Button, GridBox, H2, H3, Image, P, PortableText } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';
import React from 'react';
import timezonePlaceholderSerializer from '@ahmdigital/logic/lib/utils/sanity-timezone-placeholder-serializer';

import { ContactDetailsContent } from '../../types';
import { ImageWrapper, PhoneNumberClickable, StyledSection } from './styles';
import contactUsImage from '../../../../../../public/assets/img/call-me.svg';
import imageUrlBuilder from '../../../../cms/utils/image-url-builder';
import useGetAllPlaceholders from '../../../../components/offers/logic/use-get-all-placeholders';

// @ts-expect-error - Automatic, Please fix when editing this file
const getSubText = ({ placeholders, source }) => [
  <PortableText
    source={source}
    typeSerializers={{
      placeholder: timezonePlaceholderSerializer({ placeholders }),
    }}
  />,
];

const MEDIUM_SIZE_THRESHOLD = '60rem';
const ROW_LIMIT = 2;

const ContactDetails = ({ contact, customActionsComponent, imageObject, name, urlObject }: ContactDetailsContent) => {
  const { placeholders } = useGetAllPlaceholders();
  const contactInfo = getSubText({ placeholders, source: contact.descriptionRaw });
  const hasValidUrlObject = urlObject?.url && urlObject?.name;
  const hasValidImageObject = Boolean(imageObject?.image?.asset?.url);
  const imageSrc = hasValidImageObject
    ? // @ts-expect-error - Automatic, Please fix when editing this file
      imageUrlBuilder(imageObject.image.asset).width(undefined).height(500).url()
    : contactUsImage.src;

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <StyledSection variant={['paddingTopSpacer4', 'paddingBottomSpacer4']}>
          <AxisSwitcher limit={ROW_LIMIT} threshold={MEDIUM_SIZE_THRESHOLD}>
            <ImageWrapper isFallbackImage={!hasValidImageObject}>
              <Image src={imageSrc} role="presentation" />
            </ImageWrapper>
            <div>
              <H2 looksLike="h3" variant="marginBottomSpacer10">
                {name}
              </H2>
              <H3 looksLike="h4" variant="marginBottomSpacer11">
                <Icon name="phone" size="medium" />
                <PhoneNumberClickable to={`tel:${contact.phoneNumber}`} variant="unstyleLink">
                  {contact.action}
                </PhoneNumberClickable>
              </H3>
              <P>{contactInfo}</P>
              {hasValidUrlObject ? (
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Maybe<string> | undefined; variant: string[]; to: Maybe<string> | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'.
                <Button variant={['transparentBlack', 'border']} to={urlObject.url}>
                  {urlObject.name}
                </Button>
              ) : null}
              {customActionsComponent}
            </div>
          </AxisSwitcher>
        </StyledSection>
      </GridBox>
    </BorderGridContainer>
  );
};

export default ContactDetails;
